import { render } from "./shipmentDetails.vue?vue&type=template&id=6def3994&scoped=true"
import script from "./shipmentDetails.vue?vue&type=script&lang=js"
export * from "./shipmentDetails.vue?vue&type=script&lang=js"

import "./shipmentDetails.vue?vue&type=style&index=0&id=6def3994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6def3994"]])

export default __exports__